/**
 * Enum for product status table fields
 * @readonly
 * @enum {Array}
 */
export const PRODUCT_STATUS_TABLE_FIELDS = Object.freeze([
	{ key: 'itec_sku', label: 'SKU' },
	{ key: 'name', label: 'Product Name' },
	{ key: 'total_stock_quantity', label: 'QTY' },
	{ key: 'created_at', label: 'Created at' },
	{ key: 'updated_at', label: 'Updated at' },
]);

/**
 * Enum for fast move table fields
 * @readonly
 * @enum {Array}
 */
export const FASTMOVE_TABLE_FIELDS = Object.freeze([
	{ key: 'no', label: '#' },
	{ key: 'sku', label: 'SKU' },
	{ key: 'product_name', label: 'Product Name' },
	{ key: 'qty', label: 'QTY' },
]);

/**
 * Enum for fast move type
 * @readonly
 * @enum {Object}
 */
export const FAST_MOVE_FILTER_OPTIONS = Object.freeze([
	{
		name: '24 hours',
		value: 'filter_type_day',
	},
	{
		name: 'Week',
		value: 'filter_type_week',
	},
	{
		name: 'Month',
		value: 'filter_type_month',
	},
]);
